// removed by extract-text-webpack-plugin
module.exports = {"banner":"index__banner___1atgI","wrapper":"index__wrapper___26rpx","message":"index__message___1ojG1","button":"index__button___2cs01","fadein":"index__fadein___1k3Ji"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/banner/cookies/index.scss
// module id = 367
// module chunks = 0